import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 0 32px;
`;

export const TopToScrollButtonContainer = styled.div`
  position: sticky;
  display: flex;
  flex-direction: column;
  margin-left: auto;
  bottom: 24px;
  margin-right: -16px;
  width: fit-content;
  align-self: flex-end;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;
